module.exports = __webpack_public_path__ + "static/img/coche_logo_white.1af2e11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coche_logo_white.png
// module id = 253
// module chunks = 1